import Widget from "./base.js";

export class TableOfContents extends Widget {
	componentWillMount() {
		this.state.expand = false;
		this.toggle = this.toggle.bind(this);
	}

	componentDidMount() {
		if (this.props.enable) {
			const h2s = document.querySelectorAll(".js_article-content h2");
			if (h2s.length > 0) {
				// Convert NodeList to Array for mapping
				const toc = Array.from(h2s).map((h2) => {
					return {
						title: h2.innerText,
						id: h2.id,
					};
				});

				this.setState({
					ready: true,
					toc,
				});
			}
		}

		this.setClasses();
		this.bodyEventListener();
	}

	componentDidUpdate() {
		this.setClasses();
	}

	setClasses() {
		if (this.props.position === "inside") {
			document.querySelector(".TableOfContents").classList.add("--inside");
		}
	}

	bodyEventListener() {
		const self = this;
		document.body.addEventListener(
			"click",
			(event) => {
				if (event.target.closest(".TableOfContents")) return;
				self.setState({ expand: false });
			},
			true
		);
	}

	toggle() {
		this.setState({ expand: !this.state.expand }, this.setClasses);
	}

	renderContent() {
		if (!this.state.toc) return;

		if (!this.state.expand) {
			return (
				<button class="TableOfContents__Toggle" onClick={this.toggle}>
					<i class="fa-light fa-list-ul"></i>
				</button>
			);
		}

		return (
			<div className="TableOfContents__Inner">
				<div className="TableOfContents__Head">
					<button class="TableOfContents__Toggle --close" onClick={this.toggle}>
						<i class="fa-light fa-xmark"></i>
					</button>
				</div>
				<ul class="TableOfContents__List">
					<li class="TableOfContents__Item --headline">
						<a href="#top">
							{document.querySelector(".Article__Head h1").innerText}
						</a>
					</li>
					{this.state.toc.map((item) => (
						<li class="TableOfContents__Item">
							<a href={`#${item.id}`}>{item.title}</a>
						</li>
					))}
				</ul>
			</div>
		);
	}
}
